/**
 * MILA BABY — Collection Card Swatch Hover
 * Swaps the card image when hovering over a colour swatch
 * Uses event delegation so it works regardless of DOM timing
 */

(function () {
  'use strict';

  var imageCache = {};

  function getCardImage(swatch) {
    var card = swatch.closest('.card-wrapper');
    if (!card) return null;
    return card.querySelector('.card__media img');
  }

  function swapImage(img, src) {
    if (!img || !src) return;
    var src533  = src.replace(/(\.[^.?]+)(\?.*)?$/, '_533x$1');
    var src1066 = src.replace(/(\.[^.?]+)(\?.*)?$/, '_1066x$1');
    img.src = src533;
    img.srcset = src533 + ' 533w, ' + src1066 + ' 1066w';
  }

  // Store original image per card
  var originals = new WeakMap();

  document.addEventListener('mouseover', function (e) {
    var swatch = e.target.closest('.mila-card-swatch');
    if (!swatch) return;

    var img = getCardImage(swatch);
    if (!img) return;

    // Store original on first hover of any swatch in this card
    var card = swatch.closest('.card-wrapper');
    if (!originals.has(card)) {
      originals.set(card, { src: img.src, srcset: img.srcset });
    }

    var variantUrl = swatch.getAttribute('href');
    var variantId = variantUrl && variantUrl.split('variant=')[1];
    if (!variantId) return;

    // Use cache if available
    if (imageCache[variantId]) {
      swapImage(img, imageCache[variantId]);
      return;
    }

    // Fetch variant image
    fetch('/variants/' + variantId + '.js')
      .then(function (res) { return res.json(); })
      .then(function (variant) {
        if (variant.featured_image && variant.featured_image.src) {
          imageCache[variantId] = variant.featured_image.src;
          swapImage(img, variant.featured_image.src);
        }
      })
      .catch(function () {});
  });

  document.addEventListener('mouseout', function (e) {
    var swatch = e.target.closest('.mila-card-swatch');
    if (!swatch) return;

    // Only restore if we're leaving the swatch group entirely
    var relatedTarget = e.relatedTarget;
    if (relatedTarget && relatedTarget.closest('.mila-card-swatches') === swatch.closest('.mila-card-swatches')) {
      return; // Still hovering within the swatch group
    }

    var card = swatch.closest('.card-wrapper');
    var img = getCardImage(swatch);
    var original = originals.get(card);

    if (img && original) {
      img.src = original.src;
      img.srcset = original.srcset;
    }
  });

})();